import { Component, Vue, Prop } from "vue-property-decorator";
import { TenantBizFieldServiceProxy,TenantCustomBizFieldUpdateDTO } from '@/service-proxies/app-v2/system.service-proxies'
import { DictServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import { sort } from '@/utils/sort'
import './bill.less'

const dictService = new DictServiceProxy()
const tenantBizField = new TenantBizFieldServiceProxy()
@Component
export default class CustomTable extends Vue {
  @Prop() scrollY: Number
  get columns() {
    return [
      {
        title: this.$t('page_bill_settings_sort'),
        dataIndex: 'sort',
        key: 'sort',
        width: 120,
        customRender: (sort, record, index) => {
          return (
            <a-input-number  min={1} value={sort} style="width: 80px"
            onBlur={e => this.onSortBlur(e, record.id)}
            onChange={e => this.handleInputChange(e, record.id)}
            />
          )
        },
      },
      {
        title: this.$t('page_bill_settings_code'),
        dataIndex: 'code',
        key: 'code',
        width:200,
        customRender: (value, _record, index) => {
          return (
            <span>
              { value }
            </span>
          )
        },
      },
      {
        title: this.$t('page_bill_settings_name'),
        dataIndex: 'title',
        key: 'title',
        width:250,
        customRender: (value, _record, index) => {
          return (
            <div>
              {_record.editable ? <span class="table-span"><a-input
                style="margin: -5px 0"
                value={value}
                onChange={e => this.handleChange(e.target.value, _record.id, 'title')}
              /></span> : <span class="table-span"> {value}</span>}
            </div>
          )
        },
      },
      {
        title: this.$t('page_bill_settings_tip'),
        dataIndex: 'tip',
        key: 'tip',
        width:250,
        customRender: (value, _record, index) => {
          return (
            <div>
              {_record.editable ? <span class="table-span"><a-input
                style="margin: -5px 0"
                value={value}
                onChange={e => this.handleChange(e.target.value, _record.id, 'tip')}
              /></span> : <span class="table-span"> {value}</span>}
            </div>
          )
        },
      },
      {
        title: this.$t('page_bill_settings_type'),
        dataIndex: 'type',
        key: 'type',
        width:150,
        customRender: (value, _record, index) => {
          return (
            <div>
              {(_record.editable && (_record.isSystem !== 1))?
              <span class="table-span">
                <a-select default-value={ this.typeOf(value) } style="width: 120px" onChange={e => this.handleChange(e, _record.id, 'type')}>
                  {
                    this.fieldTypes.map(item => {
                      return <a-select-option value={item.dictKey}>
                        {item.dictValue}
                      </a-select-option>
                    })
                  }
                </a-select>
              </span> : <span class="table-span"> { this.typeOf(value) }</span>}
            </div>
          )
        },
      },
      {
        title: this.$t('page_bill_settings_fieldcategory'),
        dataIndex: 'isSystem',
        width:150,
        customRender: (value, _record, index) => {
          return (
            <div class="editable-row-operations">
              {value === 1 ? this.$t('page_bill_settings_systemfields') : this.$t('page_bill_settings_extendedfields')}
            </div>
          )
        },
      },
      {
        title: this.$t('page_bill_settings_required'),
        dataIndex: 'isRequired',
        key: 'isRequired',
        width: 105,
        customRender: (value, _record, index) => {
          return (
            <div class="editable-row-operations">
              <a-checkbox disabled={!_record.editable || (_record.isSystem === 1)} checked={value == 1} onChange={e => this.handleChange(e.target.checked, _record.id, 'isRequired')} />
            </div>
          )
        },
      },
      {
        title: this.$t('page_bill_settings_display'),
        dataIndex: 'isDisplay',
        key: 'isDisplay',
        width:300,
        customRender: (value, _record, index) => {
          return (
            <div class="editable-row-operations">
              <a-select
                allowClear
                disabled={!_record.editable}
                checked={value == 1}
                mode="multiple"
                size="small"
                value={this.displayValue(value)}
                style="width: 100%"
                onChange={e => this.handleChange(e, _record.id, 'isDisplay')}
              >
                <a-select-option key={1}>
                  {this.$t('page_bill_settings_form')}
                </a-select-option>
                <a-select-option key={2}>
                  {this.$t('page_bill_settings_list')}
                </a-select-option>
                <a-select-option key={4}>
                  {this.$t('page_bill_settings_gaosearch')}
                </a-select-option>
              </a-select>
            </div>
          )
        },
      }
    ]
  };

  data = []
  cacheData = []
  fieldTypes = []
  Rowkey = ''
  bizCode = ''
  dataType = ''
  loading= false

  getData(bizCode,value){
    this.loading = true
    this.bizCode = bizCode
    this.dataType = value
    this.data = []
    this.cacheData = []
    tenantBizField.getTenantBizField(bizCode,value).then(res => {
      this.loading = false
      if(res && res.length > 0){
        this.data = sort(res)
        this.cacheData = this.data.map(item => ({ ...item }))
        dictService.dictionary('field_type').then(fileds =>{
          if(fileds.data && fileds.data.length >0){
            this.fieldTypes = fileds.data
          }
        })
      }
    })
  }

  displayValue(value){
    if(value == 0){
      return [ ]
    } else {
      const data = []
      const numb = [1,2,4]
      numb.forEach(res =>{
        if((Number(res) & Number(value)) == res){
          data.push(res)
        }
      })
      return data
    }
  }

  typeOf(value){
    this.fieldTypes.forEach(res =>{
      if(res.dictKey == value){
        value = res.dictValue
      }
    })
    return value
  }

  handleChange(value, key, column) {
    if(column === 'isDisplay'){
      if(value.length > 0){
        value = eval(value.join("+"));
      } else {
        value = 0
      }
    }
    const newData = [...this.data];
    const target = newData.find(item => key === item.id);
    if (target) {
      target[column] = (typeof(value) === 'string' ? value.replace(/\s*/g,"") : value);
      this.data = newData;
    }
  }

  edit(key) {
    if(this.$store.getters.buttons.indexOf('page_bill_settings_edit') !== -1){
      this.$emit('edit')
      this.Rowkey = key;
      const newData = [...this.data];
      const target = newData.filter(item => key === item.id)[0];
      if (target) {
        target.editable = true;
        this.data = newData;
      }
    }
  }
  onSortBlur(e: any, key: string) {
    console.log('222', e, e.target.value)
    const value = Number(e.target.value)
    // 找到当前改变的是哪条数据
    const index = this.data.findIndex(res => res.id === key)
    // 现在要把这条数据
    const delArr = this.data.splice(index, 1)
    this.data.splice(value - 1, 0, delArr[0])
    this.data.forEach((res, index) => {
      res.sort = index + 1
    })
  }

  handleInputChange(value: any, key: string) {
    // console.log('输入框：', value, key, column)
    const newData = [...this.data]
    const target = newData.filter(item => key === item.id)[0]
    if (target) {
      target['sort'] = value
    }
    this.data = newData
  }

  save() {
    const value = []
    this.data.forEach((res,index) =>{
      const element = new TenantCustomBizFieldUpdateDTO({
        id: res.id,
        isDisplay: res.isDisplay,
        isRequired: res.isRequired ? 1 : 0,
        isSystem: res.isSystem,
        sort: index + 1,
        tip: res.tip === "" ? this.cacheData.find(item => item.id === res.id).tip : res.tip,
        title: res.title === "" ? this.cacheData.find(item => item.id === res.id).title : res.title,
        type: res.type,
      })
      value.push(element)
    })
    tenantBizField.updateBizSystemField(value).then(res =>{
      this.getData(this.bizCode,this.dataType)
      this.Rowkey = ''
      this.$emit('closeEdit')
      this.$message.success(this.$t('page_docdirectory_edit_success'))
    })
  }

  render() {
    return (
      <div>
        { !this.loading ? (this.data.length > 0) ?
            <ml-table
              pagination={false}
              columns={this.columns}
              dataSource={this.data}
              bordered
              isInsert={true}
              selectRowKey={this.Rowkey}
              canChangeColWidth={true}
              canFixedHead={true}
              scroll={this.scrollY ? { y: this.scrollY, x: 1335 } : { x: 1335 }}
              customRow={(record) => {
                return {
                  on: { // 事件
                    dblclick: () => this.edit(record.id),       // 点击行
                  },
                };
              }}
            >
            </ml-table> :
          <div style="width: 100%;height: 300px;display: flex;align-items: center;justify-content: center;"><wm-empty text={this.$t('page_wm_empty')} /></div>
           : <div style="width: 100%; height: 100%; text-align: center; padding-top: 20%;"><a-spin size="large" spinning={this.loading} /></div>
        }
      </div>
    )
  }
}
